// FilterHeader.tsx – Component header tùy chỉnh
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { IHeaderParams } from 'ag-grid-community';
import { DatePicker } from 'antd';
import { Dayjs } from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import useLoading from '../../../../../hook/useLoading';
import useThrottle from '../../../../../hook/useThrottle';
import useDebounce from '../../../../../hook/useDebounce';
import ModalFilterTable from './ModalFilterVehicleVersionTable';
import { dataVehicleStatus } from '../../../../../services/data';

export interface IDataDefaulFilterList {
  search?: string;
  status?: number[];

}


interface FilterHeaderProps {
  columnCode?: string;
  dataFilterList?: IDataDefaulFilterList
  setDataFilterList?: (dataFilterList: IDataDefaulFilterList) => void,
  closeModalFilter: (isClose: boolean) => void,

}

const FilterHeaderVehicleVersionTable: React.FC<FilterHeaderProps> = (props) => {
  const pushLoading = useLoading()

  const {
    columnCode, dataFilterList,
    setDataFilterList,closeModalFilter
  } = props;

  const prevSearchRef = useRef<string | undefined>(undefined);
  const scrollRef = useRef<Record<string, HTMLDivElement | null>>({});

  const hiddenFilterIcon = new Set(['']);
  const isHiddenFilterIcon = hiddenFilterIcon.has(columnCode || "");

  const [openModal, setOpenModal] = useState(false)

  const [checkShowSearch, setCheckShowSearch] = useState(false);

  const [checkedValues, setCheckedValues] = useState<(string | number)[]>();

  const [search, setSearch] = useState<string>()

  const toNumberArray = (arr: (string | number)[]) => {
    return arr.map(Number).filter(Number.isFinite) as number[]
  }

  const toStringArray = (arr: (string | number)[]) => arr.map(String);

  const gSLFilterData = () => {
    if (openModal) {
      switch (columnCode) {
        case 'own_vehicle_status':
          return dataVehicleStatus.map(item => ({
            id: item.value,
            title: item.label,
          }));;
        default:
          return [];
      }

    } else {
      return []
    }
  }

  // const isColumnFiltered = useMemo(() => {
  //   if(!dataFilterList) return
  //   switch (columnCode) {
  //     case 'own_vehicle_status': return !!dataFilterList.status?.length;
  //     default: return false;
  //   }
  // }, [columnCode, dataFilterList]);


  const handleSortRequest = (order: 'asc' | 'desc' | null) => {
    // let newSort: null | 'asc' | 'desc' = null;
    // switch (order) {
    //   case 'asc':
    //     newSort = 'desc'
    //     break;
    //   case 'desc':
    //     newSort = null
    //     break;
    //   default:
    //     newSort = 'asc'
    //     break;
    // }
    // setActiveSort(newSort);
    // api.applyColumnState({
    //   state: [
    //     {
    //       colId: columnCode,
    //       sort: newSort || undefined,
    //     }
    //   ],
    //   defaultState: { sort: null },
    // });
  };


  const handleSearch = useDebounce((value?: string) => {
    setSearch(value);
  }, 500);

  const handleFilterClick = useThrottle(() => {
    switch (columnCode) {
      case 'own_vehicle_status':
        setCheckedValues(dataFilterList?.status)
        setCheckShowSearch(false);
        setOpenModal(true)
        break;

      default: setOpenModal(true);
        break;
    }
  }, 1000)

  const handleFilterColumnSelectChange = (columnCode: string, value: (string | number)[]) => {
    switch (columnCode) {
      case 'own_vehicle_status':
        setDataFilterList?.({ ...dataFilterList, status: toNumberArray(value) })
        break;
      default:
        break;
    }
  }
  const closeModalFilterTable = (isClose: boolean) => {
    setOpenModal(false)
    closeModalFilter(isClose)
  };

  const onPopupScroll = (e: any, columnCode: string) => {
  };

  useEffect(() => {
    if (columnCode) {
      handleFilterClick()
    }
  }, [columnCode])


  return (
    <>
      <ModalFilterTable
        isOpen={openModal}
        scrollRef={scrollRef}
        columnCode={columnCode}
        checkShowSearch={checkShowSearch}
        selectedValues={checkedValues}

        sLData={gSLFilterData()}
        handleSearch={handleSearch}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        closeModal={closeModalFilterTable}

        onPopupScroll={onPopupScroll}
      />

    </>

  );
};

export default FilterHeaderVehicleVersionTable;
